import React, { useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import form from './Form.module.css'

Errors.propTypes = {
  errors: PropTypes.array
}

export function Errors({ errors }) {
  if (!errors) return null

  return (
    <div className={form.error}>
      <ul>
        {errors.map((error, _) => <li key={_}>{error}</li>)}
      </ul>
    </div>
  )
}

export function useForm(initValues) {
  const cancelToken = useRef(axios.CancelToken.source())

  console.log("initValues", initValues)

  const prevPendingRef = useRef(false)
  const [pending, setPending] = useState(prevPendingRef.current)

  const prevErrorsRef = useRef({})
  const [errors, setErrors] = useState(prevErrorsRef.current)

  const prevSavedRef = useRef()
  const [saved, setSaved] = useState(prevSavedRef.current)

  const [values, setValues] = useState(initValues)

  const handleInputChange = ({ target: { type, name, value, checked } }) => {

    setValues({
      ...values,
      [name]: type === 'checkbox' ? checked : value,

      amount: name == "amount" ? ((value) => {
        let arr = value.replace(/[^0-9\.,]/g, '').split(/[\.,]/);
        if (!arr.length)
          return '';
        let first = arr.shift();
        if (!arr.length)
          return first;
        return [first, arr.join('')].join('.');
      })(value) : values.amount,


      // contract: name == "contract"
      //   ? value
      //   : name == "roomNumber"
      //     ? values.contract.split(" ", 1) + " " + value
      //     : values.contract

    })
  }

  const onSubmit = useCallback(
    handleSubmit => async e => {
      e.preventDefault()

      if (pending) {
        return null
      } else {
        // console.log('SET FIRST TIME')
        setErrors({})
        setPending(true)
        setSaved(false)
      }

      await handleSubmit(e)

      setPending(false)
    }
  )

  return {
    values,
    setValues,
    errors,
    setErrors,
    saved,
    setSaved,
    onSubmit,
    pending,
    cancelToken,
    handleInputChange
  }
}
